export default "__VITE_ASSET__Cnc$7B6j__"